import {
  Required,
  Schema,
  TextField,
  RemoteDataSource
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";
import { WebUserRoleAdminOnlyFk } from "../webUserRole/schema";

export const WebUserRoleMappingSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    //id, login, first_name, last_name, email, web_role_ref, customer_ref
    {
      name: "ssoRoleName",
      type: TextField(Required),
      title: t("hns:auth:ssoRoleName")
    },
    {
      name: "webRoleRef",
      type: WebUserRoleAdminOnlyFk,
      title: t("hns:auth:role")
    }
  ]
});

mainStore.webUserRoleMapping = RemoteDataSource.create({
  api: api,
  name: "webUserRoleMapping",
  schema: WebUserRoleMappingSchema,
  url: "/webUserRoleMappings",
  commons: mainStore.commons
});
